import { render, staticRenderFns } from "./BaseSponsorScroll.vue?vue&type=template&id=8596b20c&scoped=true&"
import script from "./BaseSponsorScroll.vue?vue&type=script&lang=js&"
export * from "./BaseSponsorScroll.vue?vue&type=script&lang=js&"
import style0 from "./BaseSponsorScroll.vue?vue&type=style&index=0&id=8596b20c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8596b20c",
  null
  
)

export default component.exports